// extracted by mini-css-extract-plugin
module.exports = {"padding":"Paginator_padding__2NvFv","loadMore":"Paginator_loadMore__NyiFw","link":"Paginator_link__3fOAg"};